import Nav from "../Wifi/Nav";
import Product from "./Product";
import Location from "./Location";
import Footer from "./Footer";

export default function Home() {
    return(
        <div>
            <Nav />
            <Product />
            <Location />
            <Footer />
        </div>
    )
}